let ws
let timeout
let storeRef
export function socket (store) {
  const socketEnabled = true
  storeRef = store
  if (socketEnabled) {
    startSocketConnection()
    console.log('>>>>> Setting up socket.')
  } else {
    console.log('>>>>>  Skipping socket setup.')
  }
}

const startReconnect = () => {
  // TODO: make this work by calling store action
  timeout = setTimeout(function () {
    console.log('>>>>> Socket attempting reconnect')
    startSocketConnection()
  }, 10 * 1000)
}
const startSocketConnection = () => {
  try {
    const url = process.env.VUE_APP_OWAL_WS_URI
    // const url = `wss://ws.qa.api.owal.io`
    // const url = `ws://localhost:3030`
    ws = new WebSocket(url)
    ws.onerror = (err) => {
      console.error('>>>>> Socket communication error')
      console.log(err)
    }
    ws.onopen = () => {
      console.log('>>>>> Socket connection open.')
      authenticate(storeRef.getters.authToken)
    }

    ws.onmessage = ({ data }) => {
      const message = data ? JSON.parse(data) : undefined
      console.log('>>>>> received message', message)
      const type = message ? message.type : undefined
      switch (type) {
        case 'AUTHENTICATED':
          clearTimeout(timeout)
          subscribe(storeRef.getters.currentDomainUUID, storeRef.getters.authToken)
          break
        case 'AUTH_FAILED':
          startReconnect(storeRef.getters.authToken)
          break
        case 'ALERT':
          storeRef.dispatch('alerts/addAlert', message.alert)
          break
        default:
          console.log(message)
      }
    }

    ws.onclose = () => {
      console.log('>>>>> Closing socket connection.')
      startReconnect()
    }
  } catch (e) {
    console.error('>>>>> Socket connection error.')
    console.error(e)
  }
}

export const subscribe = (domainUUID, authToken) => {
  const message = {
    type: 'SUBSCRIBE',
    data: {
      domainUUID,
      authToken,
    },
  }
  ws.send(JSON.stringify(message))
}

const authenticate = (authToken) => {
  const message = {
    type: 'AUTHENTICATE',
    data: {
      authToken,
    },
  }
  ws.send(JSON.stringify(message))
}
